import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { getApiErrorMessage } from './helpers/apiErrorMessage';

function OtherUserList() {
    const { userId, listId } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [listTitle, setListTitle] = useState('List');
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            setError(null);
            try {
                const [userRes, listsRes, entriesRes] = await Promise.all([
                    axios.get(`/api/users/${userId}`),
                    axios.get(`/api/users/${userId}/lists`),
                    axios.get(`/api/users/${userId}/lists/${listId}`)
                ]);
                setUser(userRes.data);
                setEntries(entriesRes.data);
                const foundList = listsRes.data.find((item) => String(item.listId) === String(listId));
                if (foundList) {
                    setListTitle(foundList.title);
                }
            } catch (err) {
                setError(getApiErrorMessage(err, 'load this user list'));
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [userId, listId]);

    if (loading) {
        return <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">Loading...</div>;
    }

    if (!user) {
        return <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">User not found</div>;
    }

    return (
        <div className="min-h-screen bg-gray-900 text-white px-6 pb-10">
            {error && (
                <div className="bg-red-900 border-l-4 border-red-600 p-4 m-4 rounded">
                    <div className="flex justify-between items-center">
                        <p className="text-red-200">{error}</p>
                        <button onClick={() => setError(null)} className="text-red-400 hover:text-red-200 text-2xl">×</button>
                    </div>
                </div>
            )}
            <div className="max-w-4xl mx-auto">
                <button onClick={() => navigate(`/profile/${userId}/lists`)} className="text-gray-400 hover:text-white mb-6 flex items-center gap-2 transition">
                    <i className="fas fa-arrow-left"></i> Back to all lists
                </button>
                <h1 className="text-3xl font-bold mb-1">{user.username}</h1>
                <h2 className="text-xl text-gray-300 mb-6">{listTitle}</h2>

                {entries.length === 0 ? (
                    <p className="text-gray-400">This list has no entries yet.</p>
                ) : (
                    <div className="space-y-4">
                        {entries.map((entry) => (
                            <div key={entry.listEntryId} className="bg-gray-800 p-4 rounded-lg flex gap-4 items-center">
                                <img
                                    src={entry.album.albumCover || 'https://placehold.co/75x75'}
                                    alt={entry.album.title}
                                    className="w-14 h-14 rounded-lg object-cover"
                                />
                                <div className="min-w-0 flex-1">
                                    <p className="text-white font-semibold truncate">{entry.album.title}</p>
                                    <p className="text-gray-400 text-sm truncate">{entry.album.artist}</p>
                                    {entry.comment && <p className="text-gray-300 text-sm mt-1 line-clamp-2">{entry.comment}</p>}
                                </div>
                                <p className="text-gray-300 text-sm shrink-0">{entry.addedOn}</p>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default OtherUserList;
